import React, { useEffect, useRef } from "react";
import { notifActions } from "../../../../context/actions/notifActions";
import useStore from "../../../../context/useStore";

const NotifModal = () => {
  const [state, dispatch] = useStore();
  const actions = notifActions(state, dispatch);
  const notifProps = state.notif;
  const refPanneau = useRef(null);

  useEffect(() => {
    if (!notifProps.isOpen) return undefined;
    const fermer = () => dispatch({ type: "NOTIF_UPDATE", payload: { isOpen: false } });
    const surClavier = (evenement) => {
      if (evenement.key === "Escape") fermer();
    };
    const surClic = (evenement) => {
      if (refPanneau.current && !refPanneau.current.contains(evenement.target)) fermer();
    };
    document.addEventListener("keydown", surClavier);
    document.addEventListener("click", surClic);
    return () => {
      document.removeEventListener("keydown", surClavier);
      document.removeEventListener("click", surClic);
    };
  }, [notifProps.isOpen, dispatch]);

  return (
    <div
      ref={refPanneau}
      className={`position-fixed bg-white notif-container notif-panneau px-3 py-2 shadow-lg ${
        notifProps.isOpen
          ? "animated fadeInDown faster"
          : "animated fadeOutUp faster"
      }`}
      style={{
        width: "min(100%, 375px)",
        borderRadius: 10,
      }}
    >
      <div
        className="d-flex justify-content-end text-success cursor-pointer font-weight-bold pb-3"
        style={{
          fontSize: 16,
        }}
        onClick={() => actions.updateNotif({ isOpen: false })}
      >
        <i className="fa fa-times" />
      </div>
      {notifProps.content}
      <div
        className="d-flex justify-content-end text-success cursor-pointer font-weight-bold py-2"
        style={{
          fontSize: 16,
        }}
        onClick={() => actions.updateNotif({ isOpen: false })}
      >
        Fermer
      </div>
    </div>
  );
};

export default NotifModal;
